/**
 * HomeHowItWorks — how we work with a client.
 *
 * A project process, not a signup funnel: it starts by understanding the
 * problem, which is what the company's positioning promises. The connecting
 * line on desktop makes it read as a sequence rather than four loose cards.
 */
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Waan ku dhegeysanaa",
    body: "Waxaan fahamnaa sida ganacsigaagu u shaqeeyo iyo waxa kaa dhibaya — lataliin bilaash ah.",
  },
  {
    n: "02",
    title: "Xal ayaan qorshaynaa",
    body: "Waxaan kuu soo bandhignaa nidaamka ku habboon, waqtiga iyo qiimaha — hor inta aan la bilaabin.",
  },
  {
    n: "03",
    title: "Waan dhisnaa",
    body: "App, website, suuq ama nidaam gaar ah — waan dhisnaa, waana ku tijaabinaa.",
  },
  {
    n: "04",
    title: "Waan kula soconnaa",
    body: "Hosting, ilaalin, cusboonaysiin iyo taageero joogto ah kadib markaan bilowno.",
  },
];

export default function HomeHowItWorks() {
  return (
    <section id="how" className="py-16 sm:py-20" style={{ background: "var(--bg-muted)" }}>
      <div className="mx-auto max-w-6xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.4 }}
          className="mx-auto max-w-2xl text-center"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-muted">
            Sida aan u shaqeyno
          </span>
          <h2
            className="font-heading mt-4 text-navy"
            style={{ fontSize: "clamp(1.5rem, 2.8vw, 2rem)", fontWeight: 800, letterSpacing: "-0.03em" }}
          >
            Waxaan ka bilownaa dhibaatada
          </h2>
        </motion.div>

        <div className="relative mt-10">
          {/* Connecting line — desktop only, sits behind the cards. */}
          <div
            className="absolute left-0 right-0 top-[38px] hidden lg:block"
            style={{
              height: 1,
              background:
                "linear-gradient(90deg, transparent, var(--border-strong) 12%, var(--border-strong) 88%, transparent)",
            }}
          />

          <div className="relative grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, i) => (
              <motion.div
                key={step.n}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="text-center lg:text-left"
              >
                <span
                  className="font-heading mx-auto flex h-[52px] w-[52px] items-center justify-center lg:mx-0"
                  style={{
                    background: "var(--bg-card)",
                    border: "1px solid var(--border-strong)",
                    borderRadius: "var(--radius-md)",
                    fontSize: "1rem",
                    fontWeight: 800,
                    color: "var(--accent)",
                  }}
                >
                  {step.n}
                </span>
                <h3 className="font-heading mt-5 text-base font-bold text-navy">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
                  {step.body}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
